import axios from "axios";
const SERVER_URL = 'https://compelion.com/api/' //prod
// const SERVER_URL = "http://43.204.64.32:4000/"; // dev
// const SERVER_URL = 'http://127.0.0.1:8000/' // dev
// const SERVER_URL = "http://compelionloadbalancer-1950178212.eu-north-1.elb.amazonaws.com/"; // dev
const instance = axios.create({ baseURL: SERVER_URL, withCredentials: true });

export default instance;
